/**
 * Central de notificações do back-office (A14, Onda 7.4) — espelha os DTOs de
 * `originei-notificacoes` (`NotificacaoAdminController`).
 */
export type StatusNotificacao = 'PENDENTE' | 'ENVIADA' | 'FALHA' | 'LIDA'
export type CanalNotificacao = 'EMAIL' | 'SMS' | 'PUSH' | 'IN_APP'

export const STATUS_NOTIFICACAO: StatusNotificacao[] = ['PENDENTE', 'ENVIADA', 'FALHA', 'LIDA']
export const CANAIS_NOTIFICACAO: CanalNotificacao[] = ['EMAIL', 'SMS', 'PUSH', 'IN_APP']

/** Mesmos valores de `TipoEvento` no backend (um template por evento). */
export const EVENTOS_NOTIFICACAO = [
  'DOCUMENTO_ANALISADO',
  'DOCUMENTO_PROCESSADO',
  'CLIENTE_CRIADO',
  'CLIENTE_ATUALIZADO',
  'OPORTUNIDADE_CRIADA',
  'ESTAGIO_ATUALIZADO',
  'OPORTUNIDADE_CONTRATADA',
  'PENDENCIA_CRIADA',
  'RESERVA_VENCENDO',
  'RENOVACAO_ANALISADA',
  'RESERVA_TRANSFERIDA',
  'RESERVA_ENVIADA_ANALISE',
  'SIMULACAO_CRIADA',
  'LEMBRETE_ACAO',
  'LEMBRETE_AGENDAMENTO',
] as const

export interface NotificacaoAdmin {
  id: string
  destinatario: string
  canal: CanalNotificacao
  evento: string
  titulo: string
  conteudo: string
  status: StatusNotificacao
  erro?: string | null
  tentativas: number
  /** "yyyy-MM-dd HH:mm:ss" (JsonFormat do backend). */
  criadaEm: string
  enviadaEm?: string | null
  lidaEm?: string | null
}

export interface NotificacaoHistoricoFiltro {
  status?: StatusNotificacao | ''
  canal?: CanalNotificacao | ''
  evento?: string
  destinatario?: string
  /** LocalDateTime ISO sem fuso (YYYY-MM-DDTHH:mm:ss). */
  de?: string
  ate?: string
}

export interface NotificacaoAdminResumo {
  total: number
  enviadas: number
  /** Enviadas sem confirmação de leitura (status ENVIADA) — e-mail/SMS nunca confirmam. */
  naoLidas: number
  falhas: number
  pendentes: number
  templates: number
}

export interface NotificacaoAdminDetalhe {
  notificacao: NotificacaoAdmin
  maxTentativasAutomaticas: number
  naDlq: boolean
  reprocessavel: boolean
  topicoDlq: string
}

export interface NotificacaoReprocessarResultado {
  reprocessada: boolean
  mensagem: string
  notificacao: NotificacaoAdmin
}
